import React from 'react';
import { Page } from '../Common/Components/Page';
import { PickingAreasContent } from './Components/PickingAreasContent';

export const PickingAreas = (): React.JSX.Element => (
  <Page title="Picking: Areas" accessKey={'pickingAreas'} isSearchable={true}>
    <PickingAreasContent />
  </Page>
);
